import { useEffect, useReducer } from 'react';
import windowWidthStore, {
  INITIAL_IS_MOBILE_VIEW,
} from 'src/store/windowWidth/windowWidthStore';
import {
  WindowWidthStoreKind,
  WindowWidthStoreType,
} from 'src/store/windowWidth/windowWidthStore.types';
export interface WindowWidthHook {
  state: WindowWidthStoreType;
}
export const useWindowWidthHook = (): WindowWidthHook => {
  const [state, dispatch] = useReducer(
    windowWidthStore,
    INITIAL_IS_MOBILE_VIEW
  );

  useEffect(() => {
    function handleResize(): void {
      const isMobileView = window.innerWidth < 499;
      if (state.isMobileView !== isMobileView) {
        dispatch({
          type: WindowWidthStoreKind.INITIAL,
          payload: { isMobileView },
        });
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [window.innerWidth]);

  return { state };
};
